/* Blessac mega nav v2 — vignette swap.
   Open/close, keyboard and aria live in Horizon's header-menu.js; this module
   only swaps the panel's single vignette (image + captions) to follow the
   hovered/focused item, per the approved mockup (nav-menu.js).
   Event delegation on document survives section re-renders and morphs. */

function swapFrom(link) {
  const panel = link.closest('.blessac-mega');
  if (!panel) return;
  const img = panel.querySelector('.blessac-mega__show img');
  const capT = panel.querySelector('.blessac-mega__cap-t');
  const capS = panel.querySelector('.blessac-mega__cap-s');
  if (!img || !capT || !capS) return;
  img.src = link.dataset.img;
  capT.textContent = link.dataset.t || '';
  capS.textContent = link.dataset.s || '';
}

document.addEventListener('mouseover', (e) => {
  const link = e.target.closest?.('.blessac-mega__list a[data-img]');
  if (link) swapFrom(link);
});

document.addEventListener('focusin', (e) => {
  const link = e.target.closest?.('.blessac-mega__list a[data-img]');
  if (link) swapFrom(link);
});

/* Escape inside the panel closes it and returns focus to the launcher.
   Horizon's header-menu.js only closes on blur/pointer-leave; the dropdown
   a11y rule requires Esc. Additive — calls the component's public
   deactivate() instead of forking it. */
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  const panel = e.target.closest?.('.blessac-mega');
  if (!panel) return;
  const li = panel.closest('.menu-list__list-item');
  const menuEl = panel.closest('header-menu');
  li?.querySelector('a.menu-list__link')?.focus();
  requestAnimationFrame(() => menuEl?.deactivate?.({ target: menuEl, relatedTarget: null, type: 'keydown' }));
});

/* Preload all vignettes once so the first swap never flashes (~90KB total).
   Desktop fine-pointer only — at mobile widths the panel markup exists but can
   never display, and phones shouldn't pay for 9 JPGs. */
function preload() {
  if (!window.matchMedia('(pointer: fine) and (min-width: 990px)').matches) return;
  document.querySelectorAll('.blessac-mega__list a[data-img]').forEach((a) => {
    const i = new Image();
    i.src = a.dataset.img;
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', preload, { once: true });
} else {
  preload();
}
